import axios, { AxiosResponse } from 'axios'
import { BaseDataObject } from '../apis/ApiBase'
// import store from '../store'
import router from '../router'
import { Toast } from '@/components/Toast'


export const urls = (process.env.NODE_ENV === 'development' ? {
  //baseUrl: "https://mini.umiblog.cn/api"
  baseUrl: "https://api.5iyunwan.com/api"
} : {
  //baseUrl: "https://mini.umiblog.cn/api"
  baseUrl: "https://api.5iyunwan.com/api"
})

axios.defaults.baseURL = urls.baseUrl

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  // 附加参数router.currentRoute.value.query
  const url = location.search; //获取url中"?"符后的字串   
   const theRequest:any = new Object();   
   if (url.indexOf("?") != -1) {   
      const str = url.substr(1);   
      const strs = str.split("&");   
      for(let i = 0; i < strs.length; i ++) {   
         theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);   
      }   
   }
  let  query = router.currentRoute.value.query;
  if(localStorage.getItem("ticket")){
    query = Object.assign({ticket:localStorage.getItem("ticket")},query);
  }else{
    if(!router.currentRoute.value.query.ticket){
      query.ticket = theRequest.ticket;
      localStorage.setItem("ticket",String(theRequest.ticket))
    }else{
      localStorage.setItem("ticket",String(router.currentRoute.value.query.ticket))
      query = router.currentRoute.value.query;
    }
  }
  // if(router.currentRoute.value.query.ticket){
  //   localStorage.setItem("ticket",String(router.currentRoute.value.query.ticket))
  //   query = router.currentRoute.value.query;
  // }else{
  //   query = Object.assign({ticket:localStorage.getItem("ticket")},query);
  // }

  
  


  
  config.params = Object.assign({}, query, config.params, {
    t: Math.random()
  })
  if (config.params['noLoading']) {
    delete config.params['noLoading']
    return config
  }
  return config
})

axios.interceptors.response.use((response: AxiosResponse<BaseDataObject>) => {
  // 如果请求的域名不是我要的，那就放行到下一个拦截器
  if (response.config.url?.startsWith('http')) return response
  const data = response.data
  if (data.status == 0) {
    return response
  }else if(data.status === 10001){
    localStorage.removeItem("ticket")
    if(router.currentRoute.value.query.parent){
      if(router.currentRoute.value.name === "DoubleOne"){
        window.location.href = urls.baseUrl+"/service/login/pocketRiceTicketPubAccount/preJump?parent="+router.currentRoute.value.query.parent+"&router="+router.currentRoute.value.name
      }else{
        window.location.href = urls.baseUrl+"/service/login/pocketRiceTicketPubAccount/preJump?parent="+router.currentRoute.value.query.parent
      }
    }else{
      if(router.currentRoute.value.name === "DoubleOne"){
        window.location.href = urls.baseUrl+"/service/login/pocketRiceTicketPubAccount/preJump?router="+router.currentRoute.value.name
      }else{
        window.location.href = urls.baseUrl+"/service/login/pocketRiceTicketPubAccount/preJump"
      }
      
    }
    
  }
  if(data.view){
    Toast.toast(data.view)
  }else{
    Toast.toast('授权登录中')
  }
  return Promise.reject(new Error(data.view))
}, error => {
  Toast.toast('登录信息授权中......')
  return Promise.reject(error)
})
